import Cookies from 'universal-cookie';
import BaseStorage from './BaseStorage';

export const cookies = new Cookies();

class CookieItem extends BaseStorage {
  constructor(key, options = {}) {
    super();
    this.key = key;
    this.options = options;
  }

  get() {
    return cookies.get(this.key);
  }

  remove() {
    cookies.remove(this.key, this.options);
  }

  set(value) {
    cookies.set(this.key, value, this.options);
  }
}

export default CookieItem;



// WEBPACK FOOTER //
// ./src/utils/storage/CookieItem.js